import React, { Component } from 'react'
// import PageBuilderAddElements from './PageBuilderAddElements'
// import PageBuilderAddElements2 from './PageBuilderAddElements2'
// import PageBuilderHeader from './PageBuilderHeader'
// import PageBuilderMain from './PageBuilderMain'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsList, widgetsGroups } from '../variables/widgetsList'
import inputComponents from '../components/inputs/inputComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
// import ButtonAnimated from '../components/buttons/ButtonAnimated'
// import HttpServices from '../utils/Http.services'
// import Modal from '../components/Modal'
// import { translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import importedIcons from '../components/inputs/icons'
// import { conditionToFilterConditionGroup } from '../utils/conditionFilterFunctions'
import BottomSheet from '../components/BottomSheet'
import PageViewer from './PageViewer'
// import MenuToolbar from '../components/header/MenuToolbar'
import Header from '../components/header/Header'
// import { FormBuilderObjects } from '../variables/formBuilderData';

class PageViewerInstant extends Component {
    state = {
        type: 'dashboard',
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },

        windowData: null,
        headerConfig: {}
        // showPage:true,

    }


    componentDidMount() {
        this.init()
    }


    init = () => {

        let windowData = { path: this.props.path, params: this.props.params }

        this.setState({ windowData }, () => {
            this.bottomSheet.open()
        })

    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: false,
                    // showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }

                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }



    onClose = () => {

        // console.log(this.props.overlayInfo.id )
        // console.log("this.props.baseUrl",this.props.baseUrl,this.state.windowData)
        this.props.functionsHandler(null, 'closeOverlayFrame', { id: this.props.overlayInfo.id })

    }

    // toolbarView = () => {
    //     return (
    //         <MenuToolbar setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} permissions={this.props.permissions} isMobile={this.props.isMobile} showStack={this.state.showStack} functionsHandler={this.props.functionsHandler} colors={this.props.colors} language={this.props.language} frame={this.props.page} width={this.props.width} headers={this.props.headers} view={this.state.currentView} />
    //     )
    // }


    render() {

        return (
            <>

                <BottomSheet ref={el => this.bottomSheet = el} width={this.props.width} hideHandle={true} onClose={this.onClose}>

                    <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} changeWindow={this.changeWindow} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} permissions={this.props.permissions} frames={this.props.frames} variables={this.state.variables} updateFrames={this.props.updateFrames} addNewWindow={this.props.addNewWindow} />
                    </div>
                    {this.state.windowData && (
                        <div className='flex-1' style={{ height: 0 }}>
                            <PageViewer windowData={this.state.windowData} baseUrl={this.props.baseUrl} width={this.props.width} functionsHandler={this.props.functionsHandler} colors={this.props.colors} height={this.props.height} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={false} addNewWindow={this.props.addNewWindow} setHeader={this.setHeader} variables={this.props.variables} />
                        </div>
                    )}
                </BottomSheet>

            </>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageViewerInstant);